var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#7459AF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10336_27500",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58203 5.57812H26.3562V26.3523H5.58203V5.57812Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10336_27500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9279 5.57812C15.5596 5.57812 15.1789 5.59997 14.767 5.64667L14.9417 7.23236C15.2975 7.19472 15.6188 7.17624 15.9279 7.17624C20.775 7.17624 24.7169 11.1181 24.7169 15.9652C24.7169 20.8123 20.775 24.7542 15.9279 24.7542C15.6188 24.7542 15.3006 24.7354 14.9511 24.6951L14.773 26.2838C15.182 26.3305 15.5596 26.3523 15.9279 26.3523C21.6551 26.3523 26.315 21.6924 26.315 15.9652C26.315 10.2381 21.6551 5.57812 15.9279 5.57812ZM12.4978 6.16784C11.7643 6.42389 11.062 6.76731 10.4034 7.17927L11.2555 8.53075C11.8113 8.18095 12.4074 7.89399 13.0284 7.67557L12.4978 6.16784ZM8.58081 8.62114C8.05326 9.15171 7.56636 9.76663 7.13894 10.4471L8.49345 11.2959C8.85534 10.7156 9.26731 10.1974 9.71052 9.75118L8.58081 8.62114ZM20.1228 12.2448L15.0291 18.0593L11.6332 15.3409L10.6346 16.5896L15.2287 20.2629L21.3211 13.2935L20.1228 12.2448ZM6.12752 12.5412C5.86845 13.2905 5.69372 14.0519 5.60938 14.8073L7.19506 14.982C7.26697 14.3483 7.4165 13.7025 7.63827 13.0687L6.12752 12.5412ZM7.19808 16.9514L5.60938 17.1292C5.69674 17.8879 5.87181 18.6494 6.1339 19.3984L7.6413 18.8678C7.41986 18.2344 7.26999 17.5912 7.19808 16.9514ZM8.49345 20.6406L7.14499 21.4928C7.57275 22.1699 8.05628 22.7848 8.5872 23.3154L9.7169 22.1823C9.27067 21.7361 8.8587 21.2179 8.49345 20.6406ZM11.2619 23.4061L10.4098 24.7542C11.0684 25.1695 11.7707 25.5066 12.5072 25.7656L13.0314 24.2549C12.4105 24.0395 11.8143 23.7525 11.2619 23.4061Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/openIcon.2a652dea2c3714b007756b202e6f274a.svg";
export { ForwardRef as ReactComponent };